import { Component, OnInit, Input } from '@angular/core';
import { Appointment } from '../appointment';

@Component({
  selector: 'mc-appointment-field-detail',
  templateUrl: './appointment-field-detail.component.html',
  styleUrls: ['./appointment-field-detail.component.scss']
})
export class AppointmentFieldDetailComponent implements OnInit {

  @Input() appointment: Appointment;
  @Input() header: string;
  @Input() fieldName: string;

  constructor() { }

  ngOnInit() {
  }

  public getFieldContent() {
    return this.appointment[this.fieldName];
  }
}
